import { customTheme } from 'theme';

import { DrawerStyles } from './types';

export const defaultStyles: DrawerStyles = {
  button: {
    variant: 'outline',
    color: 'primary',
    border: '1px',
    borderColor: 'primary',
    _hover: {
      bg: 'primary',
      color: 'white',
    },
    _focus: {
      outline: 'none',
      bg: 'primary',
      color: 'white',
      boxShadow: `0 0 0 2px ${customTheme.colors.primary}`,
    },
  },
  header: {
    borderBottom: '1px solid',
    borderColor: 'gray.100',
    fontSize: 'md',
  },
  // Ensure drawer content/body layout supports internal scrolling across all pages
  content: {
    display: 'flex',
    flexDirection: 'column',
    maxH: '100vh',
    h: '100vh',
    overflow: 'hidden',
    zIndex: 1400,
  },
  body: {
    flex: 1,
    minH: 0,
    overflowY: 'auto',
    pt: 6,
  },
};
